export enum EnvKey {
  APPROVER_AFL_URL = "REACT_APP_APPROVER_AFL_URL",
  APPROVER_AFL_NBA_URL = "REACT_APP_APPROVER_AFL_NBA_URL",
  APPROVER_AFL_DAD_URL = "REACT_APP_APPROVER_AFL_DAD_URL",
  APPROVER_AFL_MATERNITY_DAD_URL = "REACT_APP_APPROVER_AFL_MATERNITY_DAD_URL",
  APPROVER_AFL_SICK_DAD_URL = "REACT_APP_APPROVER_AFL_SICK_DAD_URL",
  APPROVER_AFL_NO_SALARY_DAD_URL = "REACT_APP_APPROVER_AFL_NO_SALARY_DAD_URL",
  APPROVER_AFL_NO_SALARY_TSN_URL = "REACT_APP_APPROVER_AFL_NO_SALARY_TSN_URL",
  APPROVER_AFL_SUSPEND_CONTRACT_DAD_URL = "REACT_APP_APPROVER_AFL_SUSPEND_CONTRACT_DAD_URL",
  APPROVER_AFL_SUSPEND_CONTRACT_TSN_URL = "REACT_APP_APPROVER_AFL_SUSPEND_CONTRACT_TSN_URL",
  APPROVER_AFL_TERMINATION_CONTRACT_DAD_URL = "REACT_APP_APPROVER_AFL_TERMINATION_CONTRACT_DAD_URL",
  APPROVER_AFL_TERMINATION_CONTRACT_TSN_URL = "REACT_APP_APPROVER_AFL_TERMINATION_CONTRACT_TSN_URL",
  APPROVER_MTP_URL = "REACT_APP_APPROVER_MTP_URL",
  APPROVER_MTPS_URL = "REACT_APP_APPROVER_MTPS_URL",
  APPROVER_BC_URL = "REACT_APP_APPROVER_BC_URL",
}
